import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

// Re-export shared components for backward compatibility
export {
  PageContainer,
  ContentArea,
  SectionHeader,
  FooterWrapper,
  FooterPattern,
  Footer,
  PageNumber,
} from '../CardisPropertyCharacteristics/CardisPropertyCharacteristics.styles'

export {
  Table,
  TableRow,
  TableLabel,
  TableValue,
  TableCurrency,
  TablePercent,
} from '../../shared/CardisTable'

export { Footnote } from '../../shared/CardisTypography'

// Rename PageTitle to Title for backward compatibility
export { PageTitle as Title } from '../../shared/CardisTypography'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

// Section-specific components
export const SectionWrapper = styled.div`
  margin-bottom: 32px;

  @media print {
    margin-bottom: 32px !important;
  }
`

// Dark blue financing box - section-specific
export const FinancingBox = styled.div`
  background-color: ${cardisTheme.colors.primary};
  padding: 26px 32px;
  margin-top: 20px;

  @media print {
    background-color: ${cardisTheme.colors.primary} !important;
    padding: 26px 32px !important;
    margin-top: 20px !important;
    ${printStyles}
  }
`

export const FinancingTitle = styled.h3`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 600;
  color: ${cardisTheme.colors.white};
  margin: 0 0 20px 0;

  @media print {
    font-size: 13px !important;
    font-weight: 600 !important;
    color: ${cardisTheme.colors.white} !important;
    margin: 0 0 20px 0 !important;
    ${printStyles}
  }
`

export const FinancingRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 64px 48px 120px;
  gap: 13px;
  padding: 6px 0;
  align-items: baseline;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 64px 48px 120px !important;
    gap: 13px !important;
    padding: 6px 0 !important;
  }
`

export const FinancingLabel = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 400;
  color: ${cardisTheme.colors.white};

  @media print {
    font-size: 13px !important;
    color: ${cardisTheme.colors.white} !important;
    ${printStyles}
  }
`

export const FinancingPercent = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  text-align: right;

  @media print {
    font-size: 13px !important;
    color: rgba(255, 255, 255, 0.7) !important;
    text-align: right !important;
    ${printStyles}
  }
`

export const FinancingCurrency = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
  text-align: right;

  @media print {
    font-size: 13px !important;
    color: rgba(255, 255, 255, 0.7) !important;
    text-align: right !important;
    ${printStyles}
  }
`

export const FinancingValue = styled.span`
  font-family: ${cardisTheme.fonts.body};
  font-size: 13px;
  font-weight: 600;
  color: ${cardisTheme.colors.white};
  text-align: right;

  @media print {
    font-size: 13px !important;
    font-weight: 600 !important;
    color: ${cardisTheme.colors.white} !important;
    text-align: right !important;
    ${printStyles}
  }
`
